// Require agreement across frames; a single plausible decode must never select a product.
export function createWarehouseScanFilter() {
  let candidate = '', count = 0, candidateAt = 0, lastCode = '', lastSeen = 0;
  return (result, paused = false, now = Date.now()) => {
    const code = result?.codeResult?.code?.trim() || '';
    if (code === lastCode && code) lastSeen = now;
    if (!code && !result?.boxes?.length && now - lastSeen >= 1000) lastCode = '';
    if (paused) { candidate = ''; count = 0; return null; }
    if (!code) {
      if (now - candidateAt > 1000) { candidate = ''; count = 0; }
      return null;
    }
    const errors = (result.codeResult.decodedCodes || []).slice(1, -1)
      .map(item => item.error).filter(Number.isFinite);
    if (errors.length && (errors.some(error => error > 0.45) || errors.reduce((a, b) => a + b, 0) / errors.length > 0.25)) {
      candidate = ''; count = 0;
      return null;
    }
    const key = `${result.codeResult.format}:${code}`;
    count = key === candidate && now - candidateAt <= 1000 ? count + 1 : 1;
    candidate = key; candidateAt = now;
    if (count < 3 || code === lastCode) return null;
    lastCode = code; lastSeen = now; candidate = ''; count = 0;
    return code;
  };
}
